import React, { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import { reducer, saveLoginUrlAction } from "../redux";
import { injectReducer } from "@mochi/misc";
import { Dispatch } from "redux";

export const PrivateRoute = ({
  component: Component,
  callbackAuth,
  saveRequireLoginUrl,
  steps,
  path,
  ...args
}) => {
  const auth = callbackAuth();
  const constructionJSON = localStorage.getItem('_data') || '{}';
  const constructionData = JSON.parse(constructionJSON);
  const redirectObj: any = {
    pathname: "/"
  };

  useEffect(() => {
    if (!auth) {
      injectReducer("privateRoute", reducer);
      saveRequireLoginUrl(args.computedMatch.url);
    }
  });

  if (constructionData && constructionData.id && !auth) {
    redirectObj.search = "?construction=" + constructionData.id;
  }

  return (
    <Route
      {...args}
      render={props =>
        (auth) ? (
          <Component {...props} />
        ) : (
            <Redirect to={redirectObj} />
          )
      }
    />
  );
};

function mapStateToProps({ refreshApiToken }) {
  return {
    refreshApiToken
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  saveRequireLoginUrl: (url: string) => dispatch(saveLoginUrlAction(url))
});

export const WithReduxPrivateRoute = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrivateRoute);
